(ns dre.modals.annotator.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :annotator])

;; events
(rf/reg-event-fx
 ::clear
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  {:dispatch [::modals/clear]}))



